module.exports = __webpack_public_path__ + "img/follow_1.3c2ebe9b.png";